import { Icon, Typography } from '@scale/scaleui';
import { twMerge } from 'tailwind-merge';
import { InteractionStepType, StepParamsForTypeWithStage } from '@scale/shared/types/chat/params';

type TaskOutlineSectionProps = {
  step: StepParamsForTypeWithStage<InteractionStepType>;
  completedSteps: Record<number, boolean>;
  scrollToStep: (stepIndex: number) => void;
};

export const TaskOutlineSection = ({
  step,
  completedSteps,
  scrollToStep,
}: TaskOutlineSectionProps) => {
  const isTurn = step.turn >= 0;
  const stepIsIncomplete = !completedSteps[step.responseIndex];

  return (
    <li key={step.responseIndex} className="w-full flex items-center gap-2">
      {stepIsIncomplete ? <Icon icon="spinner" size="md" /> : <Icon icon="check" size="md" />}
      {isTurn && (
        <Typography.Paragraph3 color="text-neutral-500">{`Turn #${
          step.turn + 1
        }`}</Typography.Paragraph3>
      )}
      <a
        href="#"
        onClick={e => {
          e.preventDefault();
          scrollToStep(step.responseIndex);
        }}
        className={twMerge(
          'flex hover:underline',
          isTurn && 'pl-2 overflow-hidden text-ellipsis whitespace-nowrap w-[300px]',
        )}
        title={step.title}
      >
        <Typography.Paragraph3 className="overflow-hidden text-ellipsis whitespace-nowrap">
          {step?.title}
        </Typography.Paragraph3>
      </a>
    </li>
  );
};
